import R from "ramda";
import { store } from "store";
import { setFlashMessageAction } from "actions/app-actions";
import { requestEnvelope } from "api/envelopes";
import { trackEventAction } from "actions/shared/tracking-actions";

export const SET_COVERSHEET = "actions/manage-envelopes/set-coversheet";
export const SET_REQUEST_ENVELOPE_VISIBILITY = "actions/manage-envelopes/set-request-envelope-visibility";
export const SET_SEND_ENVELOPE_VISIBILITY = "actions/manage-envelopes/set-send-envelope-visibility";
export const SET_PROCESSING_ENVELOPES = "actions/envelopes/set-processing-envelopes";

export const setRequestEnvelopeVisibilityAction = (visibility) => ({
  type: SET_REQUEST_ENVELOPE_VISIBILITY,
  data: { visibility }
});

export const setSendEnvelopeVisibilityAction = (visibility) => ({
  type: SET_SEND_ENVELOPE_VISIBILITY,
  data: { visibility }
});

export const setCoversheetAction = (accountId) => (dispatch) => {
  const authToken = R.path(["oauth", "token"], store.getState());
  const coversheetUrl = `${API_BASE_URL}/accounts/${accountId}/coversheet?access_token=${authToken}`;
  dispatch({
    type: SET_COVERSHEET,
    data: { coversheetUrl }
  });
};

export const requestEnvelopeAction = (accountId) => (dispatch) => (
  requestEnvelope(accountId)
    .then(() => {
      dispatch(setFlashMessageAction("The squirrels have been informed. An envelope is on its way!"));
      dispatch(setRequestEnvelopeVisibilityAction(false));
      dispatch(trackEventAction("Envelope requested"));
    })
    .catch((response) => {
      dispatch(setFlashMessageAction(response.response.data.reason, "error"));
      dispatch(setRequestEnvelopeVisibilityAction(false));
    })
);



// WEBPACK FOOTER //
// ./src/js/actions/envelopes-actions.js